let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bwgIM")).then(() => parcelRequire('kSMc2'));